<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="cover">
    <div
      v-move="{
        pos: props[item.posKey],
        change: (left:number, top:number) => onPosChange(item.posKey, left, top)
      }"
      v-input="{
        value: props[item.valueKey],
        change: (value:string) => onValueChange(item.valueKey, value)
      }"
      v-for="(item, index) in info"
      :data-edit="useEdit"
      :key="index"
      :class="item.className"
      v-html="props[item.valueKey]"
    ></div>
  </div>
</template>

<script setup lang="tsx">
import { withDefaults, defineProps, defineEmits } from 'vue';

import { vMove, vInput, useCover } from './index';
import { hexToRgba } from '../pc-module-border';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const props = withDefaults(
  defineProps<{
    useEdit?: boolean;
    projectName: string;
    time: string;
    mainPageEnterpriseName: string;
    titlePosition: Pos;
    settleTimePosition: Pos;
    aspNamePosition: Pos;
    orderNumber: string | number;
    orderNumberPostion: Pos;
  }>(),
  {}
);

const emits = defineEmits(['posChange', 'valueChange']);
const { info, onPosChange, onValueChange } = useCover(emits);

document.documentElement.style.setProperty(
  '--theme-color-1-for-cover-1',
  hexToRgba(
    document.documentElement.style.getPropertyValue('--theme-color-1'),
    0.5
  )
);
</script>
<style lang="scss" scoped>
.cover {
  background-image: url('https://cdn.yxvzb.com/WEB/SaaS/bi-v3/images/coever-2-templ.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 0 130px;
  height: calc(var(--page-v3-height, 100%) - 2px);
  position: relative;
  &::after {
    content: '';
    width: 100%;
    height: 575px;
    position: absolute;
    left: 0;
    bottom: 0;
    background-image: linear-gradient(
      180deg,
      var(--theme-color-1-for-cover-1) 75px,
      var(--theme-color-1) 75px
    );
  }
}

.project-name,
.time,
.order-number,
.enterprise-name {
  position: absolute;
  z-index: 2;
  user-select: none;
}
.project-name,
.time {
  max-width: 880px;
  font-size: 63px;
  font-weight: 600;
  color: #404040;
}
.project-name {
  min-width: 600px;
  &::before {
    content: '';
    position: absolute;
    width: 149px;
    height: 11px;
    left: 0;
    bottom: -90px;
    background-color: var(--theme-color-1);
  }
}
.enterprise-name {
  font-size: 32px;
  font-weight: 500;
  color: #fff;
  max-width: 80%;
}
.order-number {
  font-size: 46px;
  font-weight: 500;
  color: #484848;
  font-family: PingFang SC;
  font-weight: 600;
}
</style>
